import React from "react";
import T from "prop-types";
import { API_BASE } from "APP_ROOT/constants";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ExternalLink from "../../../../../../shared/components/ExternalLink";

export default function RequestPreauthorization({ salesItem }) {
  if (!salesItem.shipped) return null;

  return (
    <DropDownItem>
      <ExternalLink
        style={{ color: "white" }}
        url={`${API_BASE}/sales_order_line_items/${salesItem.id}/download_customer_rma_preauthorization_form`}
      >
        <Icon name="file-text-o" fixed />
        &nbsp;RMA Pre-Authorization Form
      </ExternalLink>
    </DropDownItem>
  );
}

RequestPreauthorization.propTypes = {
  salesItem: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/RequestPreauthorization/RequestPreauthorization.jsx